export default "__VITE_ASSET__CGx2Z5Sj__"